// test1554
(1554 && 0);
